import { render, staticRenderFns } from "./taBtnYes.vue?vue&type=template&id=13b0315a&scoped=true&"
import script from "./taBtnYes.vue?vue&type=script&lang=js&"
export * from "./taBtnYes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0315a",
  null
  
)

export default component.exports